import reportByVersion from "../../../../Reports/utils/reportVersions";

import React, { Fragment } from "react";


import LoneWorkerONR from "../loneWorker";
import SafetyWatchONR from "../safetyWatch";

const JobBriefingTIMPS = (props) => {
  const { ptype, towork, tsafwat } = props.data;
  const JobBriefingTIMPSschema = reportByVersion(props.ver, "onrTIMPSJobBriefing");
  return (
    <Fragment>
      <JobBriefingTIMPSschema {...props} />
      {ptype === "LONE WORKER" ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {ptype === "SAFETY WATCH" ? <SafetyWatchONR {...props} MERGED={true} /> : null}
      {/* for new reports where all options are mutually exclusive */}
      {towork === true ? <LoneWorkerONR {...props} MERGED={true} /> : null}
      {tsafwat === true ? <SafetyWatchONR {...props} MERGED={true} /> : null}
    </Fragment>
  );
};

export default JobBriefingTIMPS;



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingTIMPS/JobBriefingTIMPS.jsx